import type { ModalActionHandler } from './modalActionTypes';
import { assignJob, getFreePopulation, MAX_BURNERS } from '../map/settlement';
import { getSettlement } from './settlementActionUtils';

export const hireBurnerAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement) return false;
    const freePop = getFreePopulation(settlement);
    const cap = MAX_BURNERS * settlement.buildings.charcoalPit.qty;
    if (settlement.jobs.burners >= cap || freePop <= 0) return false;
    if (!assignJob(settlement, 'burners')) return false;
    return true;
};
